// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();


$('.navbar-toggler').on('click',function(){
	$('#navbar').toggleClass('active');
  $(this).toggleClass('active');
});



$(window).on("scroll", function () {
	$('.dropdown-menu').removeClass('active');
  $('#lang__menu').hide();
	setTimeout(function() {
		
		$('.dropdown-menu,.dropdown-toggle').removeClass('show');
		$('.dropdown-toggle').prop('aria-expanded',false);
	}, 301);

});





$('#lang').on('click',function(){
	$('#lang__menu').fadeToggle();
});


$('.footer__menu__title').on('click',function(){
  $(this).toggleClass('active');
  $(this).siblings().toggleClass('active');
  $(this).parent('.footer__menu__col').siblings().children().removeClass('active');
  $('html, body').animate({scrollTop: '+=150px'}, 700);
});

$(window).scroll(function(){

     if ($(window).scrollTop() > 300){
      $('#scroll-page').addClass('up').removeClass('down');

	  $('#scroll-page.up').on('click',function(){
		$('html, body').animate({ scrollTop: 0 }, 400);
	  });

    } else {
      $('#scroll-page').removeClass('up').addClass('down');
    }
  });





import 'owl.carousel';
	
$(".owl-carousel__risks").owlCarousel({
    center: true,
    loop: true,
    nav:true,
    swap:false,
    dots:true,
    responsive:{
        0:{
            items:1,
			swap:false,
			nav:true
        },
		767:{
            items:3,
			swap:false,
			nav:true
        },
        993:{
            items:5,
			swap:false,
			nav:true
        }
    }
});

	
$(".owl-carousel__cultures").owlCarousel({
    loop: true,
    nav:true,
    swap:false,
    dots:true,
    responsive:{
        0:{
            items:1
        },
        993:{
            items:3
        }
    }
    });



    function checkDivLocation() {
        var $window = $(window);
        var window_bottom = $window.scrollTop() + $window.height();
      
        $('.fadeIn,.fadeInLeft,.fadeInRight').each(function(i) {
          var $that = $(this);
          var div_bottom = $that.position().top + ($that.outerHeight()/2);
      
          if (window_bottom > div_bottom) {
            $(this).addClass('visible');
          }
        });
      }
      checkDivLocation();
      
      $(window).on('scroll', function() {
        checkDivLocation();
      });



$('.risks__circle__item__btn').on('click',function(){
	$(this).addClass('active');
  $(this).parent().addClass('active');
	$(this).parent().siblings().children().removeClass('active');
  $(this).parent().siblings().removeClass('active');
	var activeContent = $(this).attr('content-active');
	$('#' + activeContent).siblings().hide();
		
		setTimeout(function(){
			$('#' + activeContent).fadeIn();
		}, 201);
});


$('.owl-carousel__risks .carousel-indicators button').on('click',function(){
  var slideNo = $(this).attr('data-bs-slide-to');
  console.log(slideNo);
  $(this).siblings().removeClass('active');
  $(this).addClass('active');
  $(this).parent().siblings().children().removeClass('active');
  $(this).parent().siblings().children(".slide__no__" + slideNo).addClass('active');
});



$('.main-accordion .main-accordion__opener').on('click',function(){
  event.preventDefault();
  $(this).toggleClass('active');
  $(this).siblings('.main-accordion__slide').slideToggle();
  $(this).parent('.main-accordion__item').siblings().children('.main-accordion__opener').removeClass('active');
  $(this).parent('.main-accordion__item').siblings().children('.main-accordion__slide').slideUp();
});


$('.photo__item').mouseenter(function(){
    $(this).sibilings().addClass('sibling');
});

$('.photo__item').mouseleave(function(){
  $(this).sibilings().removeClass('sibling');
});


$('input[type="file"]').val(null); 

$('input[type="file"]').on('change',function(){
	$('input[type="file"]').addClass('hidden');
	$("#uploaded__delete").addClass('active');
	var filename = $(this).val().replace(/.*(\/|\\)/, '');
	$('#uploaded__file').html(filename);
});

$('#uploaded__delete').on('click', function(){
	event.preventDefault();
	$(this).removeClass('hidden');
	$("#uploaded__delete").removeClass('active');
	$('input[type="file"]').removeClass('hidden');
	$('#uploaded__file').html('');
	$('input[type="file"]').val(null); 
});




$( ".photos__item" )
  .mouseover(function() {
    $( this ).siblings().addClass('sibling');
  })
  .mouseout(function() {
    $( this ).siblings().removeClass('sibling');
  });
 


  $('img.item__icon').each(function(){
    $(this).attr('width',auto);
  });
 
  $('img').each(function(){
    var imgw = $(this).width();
    var imgh = $(this).height(); 
    $(this).attr('width',imgw);
    $(this).attr('height',imgh);
  });



  


  $('.agencies__svg .agencies__region').on('click',function(){
      $('.agencies__province').removeClass('active');
      const currentProv = $(this).attr('data-name');
      $('.agencies__svg .agencies__region').removeClass('active');
      $('.agencies__svg .agencies__pin').removeClass('active');
      setTimeout(function() {
        $('#' + currentProv).addClass('active');
        $('.' + currentProv ).addClass('active');
        console.log(currentProv);
      }, 101);
  
  }); 